// Thin wrapper around Google Analytics (gtag). The gtag script is loaded
// lazily by cookie-consent.js — until the user opts in to analytics, gtag is
// undefined and every call here no-ops. After consent flips on we re-fire the
// most recent page_view so the session isn't missing its first page hit.

let lastPageView = null;

function isGtagReady()
{
    return typeof window !== 'undefined' && typeof window.gtag === 'function';
}

function buildPageLocation( path )
{
    const { origin, pathname } = window.location;
    return origin + pathname + ( path ? '#' + path : '' );
}

export function trackPageView( stateId, path )
{
    lastPageView = { stateId, path };
    if ( !isGtagReady() ) return;
    window.gtag( 'event', 'page_view', {
        page_title: stateId,
        page_path: path,
        page_location: buildPageLocation( path ),
    });
}

export function trackEvent( name, params = {} )
{
    if ( !isGtagReady() ) return;
    window.gtag( 'event', name, params );
}

if ( typeof window !== 'undefined' )
{
    window.addEventListener( 'cookie-consent:change', ( e ) =>
    {
        if ( !e.detail?.choices?.analytics ) return;
        // The gtag script tag was just unblocked; give it a moment to load
        // and execute its inline config before we send the queued page_view.
        setTimeout( () =>
        {
            if ( lastPageView && isGtagReady() )
            {
                window.gtag( 'event', 'page_view', {
                    page_title: lastPageView.stateId,
                    page_path: lastPageView.path,
                    page_location: buildPageLocation( lastPageView.path ),
                });
            }
        }, 800 );
    });
}
